import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import About from "./pages/About";
import Shop from "./pages/Shop";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import { CartProvider } from "./contexts/CartContext";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminAddProduct from "./pages/AdminAddProduct";
import EditProfile from "./pages/EditProfile";
import Checkout from "./pages/Checkout";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import UserAgreement from "./pages/UserAgreement";
import Contact from "./pages/Contact";
import Returns from "./pages/Returns";
import Shipping from "./pages/Shipping";
import OrderSuccess from "./pages/OrderSuccess";
import PaymentCallback from "./pages/PaymentCallback";
import BestSunglasses from "./pages/blog/BestSunglasses";
import BestSunglassesUnder1000 from "./pages/blog/BestSunglassesUnder1000";
import SunglassesForMen from "./pages/blog/SunglassesForMen";
import FaceShapeGuide from "./pages/blog/FaceShapeGuide";
import UVProtectionGuide from "./pages/blog/UVProtectionGuide";
import AffordableLuxury from "./pages/blog/AffordableLuxury";

function App() {

  /* WAKE RENDER BACKEND WHEN SITE LOADS */

  useEffect(() => {
    fetch("https://ecommerce-backend-zxtw.onrender.com/health")
      .then(() => console.log("Backend awake"))
      .catch(() => console.log("Backend wake failed"));
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/user-agreement" element={<UserAgreement />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/admin" element={<AdminAddProduct />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/shipping" element={<Shipping />} />
            <Route path="/best-sunglasses" element={<BestSunglasses />} />
            <Route path="/best-sunglasses-under-1000" element={<BestSunglassesUnder1000 />} />
            <Route path="/sunglasses-for-men" element={<SunglassesForMen />} />
            <Route path="/face-shape-guide" element={<FaceShapeGuide />} />
            <Route path="/uv-protection-guide" element={<UVProtectionGuide />} />
            <Route path="/affordable-luxury" element={<AffordableLuxury />} />
            

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            <Route path="/about" element={<About />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/edit-profile" element={<EditProfile />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="/payment-callback" element={<PaymentCallback />} />

          </Routes>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
